<template>
  <section class="w1312 main-content-wrap">
    <view-container :loading="loading" :empty="empty" :error="error" @retry="queryExams">
      <div class="info-container">
        <div class="info-list clearfix" v-for="(item, index) in list" :key="index">
          <div class="info-right">
            <examLink :item="item"></examLink>  
            <div class="times-count" v-if="!deadlineTimeout(item.deadline)">
              <span class="">
                总可考次数：{{item.times >= 999 ? '无限制' : item.times}}
              </span>
              <span class="mrg-lft-5" v-if="item.times < 999 && userInfo.username">
                已考次数：{{item.times - (item.makeupCount || 0)}}
              </span>
            </div>
          </div>
          <div class="info-left">
            <div class="exam-title">
              {{item.title}}
            </div>
            <div class="module-box mrg-top-10">
              <span class="item-box">
                及格：{{formatScore(item.passScore)}}
              </span>
              <span class="item-box" v-if="item.lastExamResult === 1">
                得分：{{formatScore(item.score)}}
              </span>
              <span class="item-box">
                总分：{{formatScore(item.totalScore)}}
              </span>
              <span class="item-box">
                ID：{{item.examNo}}
              </span>
            </div>
            <div class="module-box">
              <!-- <span class="item-box">
                题目总数：{{item.questionCount}}
              </span> -->
              <span class="item-box">
                时长：{{formatDuration(item.duration)}}
              </span>
              <span class="item-box" v-if="item.lastExamResult === 1">
                完成时间：{{formatTime(item.completedTime)}}
              </span>
              <span class="item-box">
                截止时间：{{formatTime(item.deadline)}}
              </span>
              <span class="item-box">
                交卷人数：{{item.finishCount}}
              </span>
            </div>
            <div class="module-box">
              <span class="item-box">
                简介：{{item.examIntro || '~'}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <pagination v-model:pageModal="page" :pageSizeList="[5, 10, 20]"/>
    </view-container>
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import pagination from '@/components/pagination.vue'
import mixins from './mixins'
export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      loading: false,
      empty: false,
      error: false,
      page: {
        pageNo: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['examsList', 'userInfo']),
    list () {
      const {
        pageNo,
        pageSize
      } = this.page
      return this.examsList.slice((pageNo - 1) * pageSize, pageNo * pageSize)
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.page.pageNo = 1
      this.page.total = 0
      this.loading = true
      this.error = false
      this.empty = false
      this.queryExams().then(() => {
        this.page.total = this.examsList.length
        if (!this.page.total) {
          this.empty = true
        }
        this.loading = false
      }).catch(() => {
        this.error = true
        this.loading = false
      })
    },
    deadlineTimeout (item) {
      if (item && Date.now() > item && item > new Date('2000/01/01 00:00:00').getTime()) {
        return true
      }
      return false
    },
    ...mapActions(['queryExams'])
  },
  components: {
    pagination
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  min-height: 216px;
  border-radius: 8px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  .info-list {
    border-bottom: 1px solid #F3F5F7;
    padding-top: 32px;
    margin-left: 32px;
    margin-right: 32px;
    padding-bottom: 32px;
    &:last-child {
      border-bottom: 0px;
    }
  }
  .info-left {
    margin-right: 150px;
  }
  .info-right {
    float: right;
    .times-count {
      text-align: right;
      margin-top: 8px;
      font-size: 14px;
      color: #999;
    }
  }
  .exam-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    color: #333;
  }
  .module-box {
    .item-box {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999;
      padding: 3px 0;
      margin-right: 26px;
    }
  }
}
</style>
